import { comparatorPayloadGeneration as comparatorPayloadGenerationIT } from './IT/comparatorPayloadGeneration'
import { comparatorPayloadGeneration as comparatorPayloadGenerationFR } from './FR/comparatorPayloadGeneration'
import { comparatorConsumption as comparatorConsumptionIT } from './IT/comparatorConsumption'
import { comparatorConsumption as comparatorConsumptionFR } from './FR/comparatorConsumption'

const payloadGeneratorByCountry = {
  it: comparatorPayloadGenerationIT,
  fr: comparatorPayloadGenerationFR,
}

const consumptionResolverByCountry = {
  it: comparatorConsumptionIT,
  fr: comparatorConsumptionFR,
}

const cityIdFieldByCountry = {
  it: 'cityId',
  fr: 'inseeCode',
}

export const comparatorCityId = ({ country, address }) => address?.[cityIdFieldByCountry[country]] || ''

export const buildComparatorPayload = ({ country, ...params }) => {
  const generator = payloadGeneratorByCountry[country] ?? null

  if (!generator) {
    throw new Error(`buildComparatorPayload: unsupported country '${country}'`)
  }

  return generator({ country, ...params })
}

export const buildComparatorConsumption = ({ country, consumptionData }) => {
  const resolver = consumptionResolverByCountry[country] ?? null

  if (!resolver) {
    throw new Error(`buildComparatorConsumption: unsupported country '${country}'`)
  }

  return resolver(consumptionData)
}
